export const AddPinIcon = (ps: React.SVGAttributes<SVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...ps}>
    <g clipPath="url(#clip0_1_2632)">
      <path
        d="M25 1.25V5H28.75V7.5H25V11.25H22.5V7.5H18.75V5H22.5V1.25H25ZM15 16.25C16.375 16.25 17.5 15.125 17.5 13.75C17.5 12.375 16.375 11.25 15 11.25C13.625 11.25 12.5 12.375 12.5 13.75C12.5 15.125 13.625 16.25 15 16.25ZM17.5 4.0625V8.75H21.25V12.5H24.9C24.9625 12.9875 25 13.4875 25 14C25 18.15 21.6625 23.0625 15 28.75C8.3375 23.0625 5 18.15 5 14C5 7.775 9.75 3.75 15 3.75C15.85 3.75 16.6875 3.85 17.5 4.0625Z"
        fill="#00BE79"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2632">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
